export default __webpack_public_path__ + "media/images/manual/ic/05-936fcc0fdbff6901ca54e891e2355374.png";